import { getAPIUrl } from "../../../shared/helper";
import Api from "../../network/axiosClients";
import { AxiosResponse } from "axios";

export const getCoverages = async (lobName: string): Promise<AxiosResponse> => {
  return Api.get(
    getAPIUrl("coverages/parents/list-of-values", {
      lineOfBusiness: lobName,
      take: 10,
      page: 1
    })
  );
};

export const getService = async (lobName: string): Promise<AxiosResponse> => {
  return Api.get(
    getAPIUrl("service/list-of-values", {
      lineOfBusiness: lobName,
      take: 10,
      page: 1
    })
  );
};

export const getPlanType = async (): Promise<AxiosResponse> => {
  return Api.get("web/plan-type?lineOfBusinessId=1&page=1&take=10&saleCategory=B2C");
};

export const getTakafulCompanies = async (lobName: string): Promise<AxiosResponse> => {
  return Api.get(
    getAPIUrl("takaful-providers/list-of-values", {
      lineOfBusiness: lobName,
      take: 50,
      page: 1,
      status: true
    })
  );
};

export const getLineOfBusiness = async (): Promise<AxiosResponse> => {
  return Api.get("line-of-businesses");
};
